export const CERT_ENTITLEMENT_VALUEKEY = {
  USER: '-4',
  ROLE: '-2',
  ACCOUNT: '0',
  ENTITLEMENT: '>0',
};

export const EO_ROW_TYPE = {
  ENTITLEMENT: '0',
  ACCOUNT: '1',
  'CHILD ENTITLEMENT': '-1',
};

export const LINEITEM_TYPES = {
  USER: 'USER',
  ACCOUNT: 'ACCOUNT',
  ENTITLEMENT: 'ENTITLEMENT',
  ROLE: 'ROLE',
  'CHILD ENTITLEMENT': 'CHILD ENTITLEMENT',
};

export const COL_FILTER_HEADER_USER = 'User';
export const COL_FILTER_HEADER_ROLE = 'Role';
export const COL_FILTER_HEADER_ACCOUNT = 'Account';
export const COL_FILTER_HEADER_ENTITLEMENT = 'Entitlement';
export const COL_FILTER_HEADER_CHILD_ENTITLEMENT = 'Child Entitlement';

export const FIXED_COL_FOR_USER = 'User_LABEL';
export const FIXED_COL_FOR_ROLE = 'Role_LABEL';
export const FIXED_COL_FOR_ACCOUNT = 'Account_LABEL';
export const FIXED_COL_FOR_ENTITLEMENT = 'Ent_LABEL';
export const FIXED_COL_FOR_CHILD_ENTITLEMENT = 'Ent2_LABEL';

export const EO_FIXED_COL_FOR_ACCOUNT = 'Account_LABEL';
export const EO_FIXED_COL_FOR_ENTITLEMENT = 'Ent_LABEL';
export const EO_FIXED_COL_FOR_CHILD_ENTITLEMENT = 'Ent2_LABEL';

// fixed columns
export const FIXED_COL_FILTERS = [
  `${COL_FILTER_HEADER_USER.toUpperCase()}-${FIXED_COL_FOR_USER}`,
  `${COL_FILTER_HEADER_ACCOUNT.toUpperCase()}-${FIXED_COL_FOR_ACCOUNT}`,
  `${COL_FILTER_HEADER_ENTITLEMENT.toUpperCase()}-${FIXED_COL_FOR_ENTITLEMENT}`,
  `${COL_FILTER_HEADER_ROLE.toUpperCase()}-${FIXED_COL_FOR_ROLE}`,
  `${COL_FILTER_HEADER_CHILD_ENTITLEMENT.toUpperCase()}-${EO_FIXED_COL_FOR_CHILD_ENTITLEMENT}`,
];

export const SORT_WARN_MSGS = {
  ROLES_AND_ACCOUNTS:
    'Sorting is disabled because both Roles and Accounts are selected as top-level items in the Rows filter. To enable sorting, select only one top-level option in the filter.',
  ROLES_AND_ENTITLEMENTS:
    'Sorting is disabled because both Roles and Entitlements are selected as top-level items in the Rows filter. To enable sorting, select only one top-level option in the filter.',
  EO_SORT_DISABLED: 'Sorting is disabled with Account and Child Entitlement',
};
